module.exports = __webpack_public_path__ + "media/packs/images/close-1dc0be53d46d87d236d292a3188d873b.svg";